define('modules/editor/behaviours/history',['require','exports','module','../models/editorstate'],function(require, exports, module) {
  "use strict";

  var EditorState = require("../models/editorstate");

  var History = {
    changes: [],
    pos: 0,
    reset: function() {
      this.changes = [];
      this.pos = -1;
    },
    _canUndo: function() {
      return this.pos > 0;
    },
    _canRedo: function() {
      return this.pos < this.changes.length - 1;
    },
    isInbounds: function() {
      return this._canUndo() && this._canRedo();
    },
    _getState: function() {
      return this.changes[this.pos];
    },
    undo: function() {
      if (this._canUndo()) {
        --this.pos;
        return this._getState();
      }
    },
    redo: function() {
      if (this._canRedo()) {
        ++this.pos;
        return this._getState();
      }
    },
    track: function(state) {
      this.changes.splice(this.pos + 1, this.changes.length - this.pos - 1);
      this.changes.push(state);
      ++this.pos;
    },
  };

  module.exports = {
    initHistory: function() {
      this.history.reset();
      this._trackState(true);
      this._restartListeners();
    },
    _restartListeners: function() {
      this.listenTo(EditorState, "variant:changed", this._trackState);
      //this.listenTo(this, "change", this._trackState);
    },
    _trackState: function(force) {
      if (force || this.get("step") === EditorState.getCurrentStep()) {
        this.history.track(this.toJSON());
        if (this.history._canUndo()) {
          this.trigger("history:track");
        }
      }
    },
    _commit: function(action) {
      this.stopListening(EditorState, "variant:changed");
      var data = this.history[action].call(this.history);
      if (!this.history.isInbounds()) {
        this.trigger("history:disable", action, false);
      }
      this.parse(data.json, {});
      this.trigger("history:commit", action, true);
      // wait for editor/views/elements/element.js:72 to finish rendering
      _.delay(_.bind(this._restartListeners, this), 150);
    },
    undo: function() {
      this._commit("undo");
    },
    redo: function() {
      this._commit("redo");
    },
    notifyHistoryStatus: function() {
      if (this.history._canUndo()) this.trigger("history:track");
      if (this.history._canRedo()) this.trigger("history:commit", "undo", true);
    },
    mixed: function(klass, proto) {
      proto.initialize = _.wrap(proto.initialize || _.identity, function(init) {
        this.history = Object.create(History);
        // Start tracking ourselves at the beginning
        this.initHistory();
        return init.apply(this, _.rest(arguments));
      });
    }
  };
});

